module.exports = __webpack_public_path__ + "Flag-204.95ac5a7640b3d567335b9e3378abfe2e.svg";